import { AssessmentMetricType } from './AssessmentMetricType.enum';

export enum DemographicsCategory {
    AGE = 'AGE',
    SEX = 'SEX',
}

export const CriteriaCategory = { ...DemographicsCategory, ...AssessmentMetricType };
export type CriteriaCategory = DemographicsCategory | AssessmentMetricType;
